<template>
  <div class="upload-image-box">
    <van-uploader :after-read="Upload" :max-count="maxCount" :preview-image="true" :disabled="isDisabled">
      <img :src="'s' | pathFilter(picUrl)" v-if="picUrl" />
    </van-uploader>
    <slot name="img-opt-fun"></slot>
    <van-loading type="spinner" color="#1989fa" v-if="loadingShow" />
  </div>
</template>
<script>
import { GetAliImageUploadPath, newClient } from '@/Api/upload';
import { Toast } from 'vant';
import { guid } from '@/utils/guid'
export default {
  props: {
    fileType: {// 上传类型: 1.图片类型, 2.文件类型, 3.压缩类型
      type: Number,
      default: 1
    },
    method: { // 上传方法名称
      type: String,
      required: true,
      default: ''
    },
    company: {// 公司:0:正雅,1:隐齿丽
      type: Number,
      default: 0
    },
    maxCount: {//图片上传数量
      type: Number,
      default: 1
    },
    picUrl: {
      type: String,
      default: ''
    },
    uploadDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    uploadDisabled: {
      handler (newVal, oldVal) {
        this.isDisabled = newVal
      },
      immediate: true
    }
  },
  data () {
    return {
      fileName: '',
      isDisabled: false,
      percentage: 0,
      loadingShow: false,
      client: null,
      uploadRegion: 'cn-shanghai',//中文版统一为 cn-shanghai
      syncRegion: 'cn-shanghai',//中文版统一为 cn-shanghai
      isAccelerate: false,//中文版统一为false
    }
  },
  methods: {
    //上传授权
    uploadGetAliAuth () {
      this.loadingShow = true
      this.isDisabled = true
      return new Promise((resolve, reject) => {
        GetAliAuth().then(res => {
          if (res) {
            resolve(res)
          } else {
            this.loadingShow = false
            this.isDisabled = false
            reject()
          }
        })
      })
    },
    //获取图片属性信息
    util (file) {
      let _that = this
      return new Promise(resolve => {
        let reader = new FileReader();
        reader.onload = function (e) {
          let data = e.target.result;
          let img = new Image();
          _that.$emit('localAttr', data)
          img.src = data;
          resolve(img);
        };
        reader.readAsDataURL(file);
      });
    },
    //校验文件类型
    checkFileType (file) {
      let errorFlag = false
      if (this.fileType === 1) {
        let type1 = file.type.split('/')[0] || file.name.split('.')[1];
        let type2 = file.type.split('/')[1] || file.name.split('.')[1];
        const imageArr = ['jpeg', 'png', 'bmp', 'gif', 'webp', 'CR2']
        let isMyImage = imageArr.indexOf(type2) != -1
        if (type1.indexOf('image') < 0 && type1 != 'CR2') {
          Toast.fail({
            duration: 2000,
            message: '不是图片'
          });
          errorFlag = true
          this.loadingShow = false
          this.isDisabled = false
        } else if (!isMyImage) {
          Toast.fail({
            duration: 2000,
            message: '图片格式不正确'
          })
          errorFlag = true
          this.loadingShow = false
          this.isDisabled = false
        }
      }
      return errorFlag
    },
    async Upload (file) {
      if (!this.checkFileType(file.file)) {
        let _that = this
        if (this.fileType === 1) {
          try {
            let img = await this.util(file.file)
            let res = await GetAliImageUploadPath(
              guid.newGUID(),
              file.file.name,
              _that.method,
              img.height,
              img.width,
              file.file.size,
              new Date().getTime(),
              _that.uploadRegion,
              _that.syncRegion,
              _that.isAccelerate
            )
            _that.client = await newClient(res, _that.uploadRegion)
            _that.client.multipartUpload(res.Path, file.file, {
              progress: function (percentage) {
                // 上传进度
                _that.percentageShow = true
                _that.percentage = Number((percentage * 100).toFixed(2))
              }
            }).then(results => {
              var nameArr = results.name.split('/')
              var name
              if (nameArr) {
                name = nameArr[nameArr.length - 1]
              }
              this.emitInput(results.name, name);
              this.loadingShow = false
            })
          } catch (e) {
            Toast.fail({
              message: '上传失败!',
              duration: '1000'
            })
            this.loadingShow = false
          }
          this.isDisabled = false
        }
      }
    },
    emitInput (url, fileName) {
      this.$emit('fileUpload', url, fileName);
    }
  }
}
</script>
<style lang="less" scoped>
.upload-image-box {
  position: relative;
  /deep/ .van-uploader {
    display: inherit;
    .van-uploader__wrapper {
      overflow: hidden;
    }
    .van-uploader__input-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    .van-uploader__wrapper--disabled {
      opacity: 1;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
    }
  }
  .van-loading {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 9;
    background: rgba(50, 50, 51, 0.88);
    .van-loading__spinner {
      top: 50%;
      margin-top: -30px;
      i::before {
        color: #ffffff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/upload/index.vue